import { Input, Row } from 'antd';
import React, { memo } from 'react';

import DefaultFormItem from 'components/composites/DefaultFormItem';
import BackOfficeEnterpriseSelect from 'components/forms/BackOfficeEnterpriseSelect/BackOfficeEnterpriseSelect';
import FormItemCol from 'components/forms/FormItemCol';

const enterpriseRules = [
  { required: true, message: 'Please select an enterprise' },
  {
    validator: (_: unknown, value: unknown) => {
      const id = Number(value);
      if (!Number.isInteger(id) || id <= 0) {
        return Promise.reject(new Error('Please select a valid enterprise'));
      }
      return Promise.resolve();
    }
  }
];

function BarnOwlCreateFormItems(): JSX.Element {
  return (
    <>
      <Row gutter={24}>
        <BackOfficeEnterpriseSelect
          placeholder="Search enterprise"
          rules={enterpriseRules}
        />
      </Row>
      <Row gutter={24}>
        <FormItemCol>
          <DefaultFormItem
            name="firstName"
            label="First name"
            rules={[{ required: true, message: 'Please enter a first name' }]}
          >
            <Input />
          </DefaultFormItem>
        </FormItemCol>
        <FormItemCol>
          <DefaultFormItem
            name="lastName"
            label="Last name"
            rules={[{ required: true, message: 'Please enter a last name' }]}
          >
            <Input />
          </DefaultFormItem>
        </FormItemCol>
      </Row>
      <Row gutter={24}>
        <FormItemCol>
          <DefaultFormItem
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter an email' },
              { type: 'email', message: 'Please enter a valid email' }
            ]}
          >
            <Input autoComplete="off" />
          </DefaultFormItem>
        </FormItemCol>
        <FormItemCol>
          <DefaultFormItem
            name="phone"
            label="Phone"
            rules={[{ required: true, message: 'Please enter a phone number' }]}
          >
            <Input autoComplete="off" />
          </DefaultFormItem>
        </FormItemCol>
      </Row>
      <Row gutter={24}>
        <FormItemCol>
          <DefaultFormItem
            name="timezone"
            label="Timezone"
            rules={[{ required: true, message: 'Please enter an IANA timezone' }]}
          >
            <Input placeholder="America/Chicago" autoComplete="off" />
          </DefaultFormItem>
        </FormItemCol>
        <FormItemCol>
          <DefaultFormItem
            name="password"
            label="Barn Owl app password"
            rules={[
              { required: true, message: 'Please enter a password' },
              { min: 8, message: 'Password must be at least 8 characters' }
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </DefaultFormItem>
        </FormItemCol>
      </Row>
    </>
  );
}

export default memo(BarnOwlCreateFormItems);
